import { mp4a } from './mp4a.js';
/**
 * Parse an AudioSampleEntry from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed AudioSampleEntry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function enca(view) {
    return mp4a(view);
}
//# sourceMappingURL=enca.js.map